<div class="wrapper">
  <div class="header">
    <div class="d-flex">
      <span (click)="navigateToLadingPage()">
        <img src="assets/images/icon/refresh.svg" />
        {{ translations['restart'] }}
      </span>
    </div>
    <div>
      <div>
        <img
          src="assets/images/ecolab-logo-white-app-header.png"
          alt="EcoLab Logo"
          class="logo h-30"
        />
      </div>
    </div>
    <select
      [value]="currentLanguage"
      (change)="languageChange($event)"
      class="select-dropdown"
    >
      <option
        *ngFor="let option of languageOptions"
        [value]="option?.value"
        [selected]="option.value === currentLanguage"
      >
        {{ option.value }}
      </option>
    </select>
  </div>

  <div>
    <img class="img-thank" src="assets/images/troubleshooting/thankYou.png" />
  </div>
  <div>
    <div class="row col-12">
      <div class="col-8">
        <div class="py-5 ps-3 thank-msg">
          {{ translations['thank_page_message'] }}
        </div>
      </div>
      <div class="col-4">
        <div class="pe-3">
          <img class="img-es" *ngIf="machineImageUrl" [src]="machineImageUrl" />
        </div>
      </div>
    </div>
  </div>
  <div class="img-container">
    <img class="img-thank" src="assets/images/troubleshooting/thankYou2.png" />
  </div>
</div>
